<template>
  <div class="total flex fd bgps">
    <div class="meng"></div>
    <theader :isShow="isShows" @updateUserInfo="()=>updateUserInfo"
      style=" position: fixed; top: 0;left: 0; z-index: 99;color: #fff;" />
    <div class="change-area" v-if="showChangeSectionFlag" >
      <changeWorkArea :chanSectionDataList="chanSectionDataList"></changeWorkArea>
    </div>
    <div class="content f1 flex pr" style="justify-content: flex-end">
      <tmenu v-if="isShows" />
      <div style="width:100vw;height:100vh">
        <mapView ref="map"    @clickEntity ='mapClick'  :equipmentPropData="equipmentData" ></mapView>
      </div>
      <div class="right">
        <div class="right-tab" v-if="isRightClick">
          <div class="right-tab-list">
            <div class="tab-item" v-for="item in rightTab" @click="clickRightTab(item)" :class="activeRightTab.name===item.name? 'active-tab':''" >
              <img class="tab-img" alt="" :src="item.icon"/>
              <div class="tab-text">{{ item.name }}</div>
            </div>
          </div>
          <div class="arrow" @click="switchRightTab" :class="isShowRightTab?'arrow-right':'arrow-left'"></div>

        </div>
        <div class="right-content" v-if="isShowRightTab" :style="!isRightClick? 'width:450px' :''">
          <component :is="activeRightTab.component" :id='iconId'></component>
          <div v-if="!isRightClick" class="right-content-delete" @click="deletBtn">
            <img class="icon" src="@/assets/image/index/删除.png"/>
          </div>
        </div>
      </div>
    <div class="center">
      <centerBtn  :equipmentPropData="equipmentData"   @btnClick="centerBtnClick"  ></centerBtn>
    </div>

    </div>

    <div>
      <el-dialog :visible.sync="dialogVisible"  width="85%" show-close="true" >
        <el-row type="flex" class="row-bg">
          <el-col :span="18">
            <el-carousel
                @change="handleCarouselChange"
                arrow="always"
                height="660px"
                ref="carousel"
            >
              <el-carousel-item
                  v-for="(item, index) in enlargedImageUrls"
                  :key="index"
                  :name="index.toString()"
              >
                <img :src="item.url" :alt="item.imageName" width="100%" height="100%" />
              </el-carousel-item>
            </el-carousel>
          </el-col>
        </el-row>
      </el-dialog>
    </div>

  </div>
</template>


<script>
import changeWorkArea from '@/components/index/changeWorkArea'
import centerBtn from "@/components/index/centerBtn.vue";
import mapView from "@/components/common/map.vue";
import projectPhoto from "@/components/index/projectPhoto.vue";
import projectOverview from "@/components/index/projectOverview.vue";
import parcticalUnit from "@/components/index/parcticalUnit.vue"
import managerPerson from "@/components/index/managerPerson.vue"
import dustMonitoring from "@/components/index/dustMonitoring.vue";
import gateView from '@/components/index/gateView.vue'
import {getEquipmentList, getSectionList} from "@/utils/indexApi";
export default {
  components:{mapView,projectPhoto,projectOverview,parcticalUnit,managerPerson,dustMonitoring,gateView,centerBtn,changeWorkArea},
  provide() {
    return {
      clickshowBigImg: this.clickshowBigImg
    };
  },
  computed:{
    currentText() {
      // 根据当前激活的幻灯片索引返回对应的文字描述
      return this.enlargedImageUrls[this.activeIndex]?.remarks;
    }
  },
  data() {
    return {
      isShows:true,
      token: "at.4yo96rl79jhd2hmbcayn319l0ohapgyb-969l6wnjho-1vyza42-f0i5ky1uz",
      rightTab:[{name:'项目效果图',component:projectPhoto,icon:require('@/assets/image/situation/iconimg.png')}
      ,{name:'工程概况',component:projectOverview,icon:require('@/assets/image/situation/iconbook.png')}
      ,{name:'参建单位',component:parcticalUnit,icon:require('@/assets/image/situation/iconhouse.png')}
      ,{name:'管理人员',component:managerPerson,icon:require('@/assets/image/situation/iconperson.png')}],
      activeRightTab:{},
      isShowRightTab:false,
      isRightClick:true, //是否是右侧点击,控制右侧tab显示
      iconId:'',
      dialogVisible: false, // 控制对话框显示
      enlargedImageUrls:  [],
      activeIndex: 0, // 当前激活的幻灯片索引
      equipmentData:{},
      showChangeSectionFlag:false,
      chanSectionDataList:[]
    };
  },
  mounted() {
  },
  created(){

    this.getSelectionList().then(()=>{
      let section = sessionStorage.getItem('currentSection')
      var sectionId = '' ;
      if(section){
        var setcionJSON = JSON.parse(section)
        sectionId = setcionJSON.id;
      }
      getEquipmentList(sectionId).then(res=>{
        this.equipmentData = res?.data?.list?res?.data: {list:[]}
      })
    })
  },
  methods: {

    filterEquipment(equip){
      console.log(equip,"equip...............")
    },
    getSelectionList(){

      return new Promise((resolve, reject) => {
        getSectionList().then(res=>{
          if(!res){
            return;
          }
          var  sectionList = res.data ||[]
          if(sectionList.length === 0){
            this.showChangeSectionFlag = false;
          }else   if(sectionList.length === 1){
            sessionStorage.setItem('currentSection',JSON.stringify(sectionList[0]))
            this.showChangeSectionFlag = false;
          }else{
            this.showChangeSectionFlag = true;
            this.chanSectionDataList = sectionList;
          }
          resolve();
        })

      });

    },
    getEquipmentList(sectionId){

      getEquipmentList(sectionId).then(res=>{
        this.equipmentData = res?.data?.list?res?.data: {list:[]}
      })
    }   ,
    handleCarouselChange(newIndex, oldIndex) {
      // 当幻灯片切换时更新激活的索引
      this.activeIndex = newIndex;
    },
    clickshowBigImg(imgList){
      this.enlargedImageUrls = imgList; // 设置放大图片的URL
      this.dialogVisible = true; // 显示对话框
    },

    clickRightTab(item){
      this.activeRightTab = item
      this.isShowRightTab = true
      this.isRightClick = true
    },
    //切换右tab展示
    switchRightTab(){
      this.isShowRightTab = !this.isShowRightTab
      if(!this.isShowRightTab){
        this.activeRightTab = {}
      }else{
        this.activeRightTab = this.rightTab[0]
        this.isRightClick = true
      }

    },
    deletBtn(){
      this.isShowRightTab = false
      this.isRightClick = true
    },
    mapClick(id,type){
      if(!type){
        this.deletBtn()
        return
      }
      const typeMap={
        '实名制通道':gateView,
        '环境监测':dustMonitoring
      }
      this.isRightClick = false
      this.isShowRightTab = true
      this.iconId = id
      this.activeRightTab = {component:typeMap[type]}

    },
    centerBtnClick(type,data){
      const typeMap= {
        reset:()=>{
          this.ratio = data
          this.$refs.map.resetProjectPosition();
          // this.$refs.map.cancelAround();

        },
        changRatio:()=>{
          this.ratio = data
          this.$refs.map.setZoomTo(data)
        },
        changFlag:()=>{


        }
      }
      typeMap[type]()
    },
  }
};
</script>



<style scoped lang="scss">
/* 设置控制盒子的样式 */
#control-box {
  width: 7.5rem;
  height: 1.875rem;
  line-height: 2.5rem;
}

.content {
  position: relative;
  width: 100%;
  height: 103%;


}
.change-area{
  width: 100%;
  position: absolute;
    top:3.0739vw;
    z-index: 98;
}

.total {
  width: 100%;
  height: 100%;
  background: url("../assets/image/bgstaff.png") no-repeat;
  position: relative;

  .jiazai {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    .img {
      width: 30%;
      height: 1.25rem;
      border: 0.0625rem solid #00c1ff;

      >img {
        width: 100%;
      }
    }

    >p {
      font-size: 1.25rem;
      margin-top: 1rem;
    }
  }

  .meng {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 98;
    width: 100%;
    height: 10%;
    background: url("../assets/image/渐变蒙层.png") no-repeat;
    background-size: 100% 100%;
    background-position: 0 0;
  }
}
.right{
  position: fixed;
  right: 0;
  top:10.18vh;
  display: flex;
  height: calc(100vh - 10.18vh);
  .right-tab{
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    flex-direction: column;
    .right-tab-list{
      display: flex;
      flex-direction: column;
      align-items: center;
      gap:20px;

      .tab-item{
        writing-mode: horizontal-tb;
        color: #fff;
        width: 2.2vw;
        height: 7.5vw;
        font-family: AlibabaPuHuiTi_2_75_SemiBold;
        font-size: 18px;
        color: #D9E7FF;
        line-height: 20px;
        text-shadow: 0px 0px 8px #00498C;
        text-align: center;
        font-style: normal;
        text-transform: none;
        background: url('@/assets/image/index/按钮背景-未选中@2x.png');
        background-size: cover;
        .tab-img{
          width: 1.25vw;
          height:1.25vw;
          margin: 16px 0  8px 0;

        }
        .tab-text{
          width: 0.73vw;
          margin: 0 auto;
          text-align:center;
          line-height: 0.73vw;

        }
      }
      .tab-item:hover{
        background: url('@/assets/image/index/按钮背景-选中@2x.png');
        background-size: cover;
        color: #fff;
      }
      .active-tab{
        background: url('@/assets/image/index/按钮背景-选中@2x.png');
        background-size: cover;
        color: #fff;
      }
    }
      .arrow{
        margin-bottom: 30px;
        width: 34px;
        height: 70px;
        transform: translateX(38%);

      }
      .arrow-left{
        background: url('@/assets/image/index/展开@2x.png') no-repeat  ;
        background-size: contain;
      }
      .arrow-left:hover{
        background: url('@/assets/image/index/展开高亮.png') no-repeat ;
        background-size: contain;
      }
      .arrow-right{
        background: url('@/assets/image/index/收起@2x.png') no-repeat ;
        background-size: contain;
      }
      .arrow-right:hover{
        background: url('@/assets/image/index/收起高亮.png') no-repeat ;
        background-size: contain;
      }
  }
  .right-content{
    width: 33.1rem;
    padding: 20px 20px 0 20px;
    overflow: auto;
    background: linear-gradient( 270deg, rgba(0,0,0,0) 0%, #1E2C3C 100%);
    border: 1px solid #364866;
    backdrop-filter: blur(10px);
    .right-content-delete{
      position: absolute;
      top: 22px;
      right: 18px;
      .icon{
        width: 24px;
        height: 24px;
      }
    }
  }
}
.center{

  position: fixed;
  left: 50%;
  bottom: 30px;
  transform: translateX(-50%);
}

.carousel-image {
  width: 100%; /* 根据需要调整图片大小 */
  height: auto;
  cursor: pointer; /* 将鼠标光标变为指针，提示可点击 */
}
::v-deep .el-dialog__header{
  padding: 0px;
}
::v-deep .el-dialog__body{
  padding: 0px;
}
::v-deep .el-col.el-col-18{
  width: 100%;
}
::v-deep .el-dialog__headerbtn{
  z-index: 10;
}
::v-deep .el-dialog__wrapper{
  overflow:visible;
}
</style>
